<div class="modal__text">אתה/את רוצה לעבור למסך אחר ללא שמירת נתונים?</div>
<div class="modal__footer">
    <button class="button button_size_small button_theme_main" (click)="accept()">כן</button>
    <button class="button button_size_small button_theme_gray-line" (click)="reject()">לא</button>
</div>
